import { Component, forwardRef, Injector, Input, OnInit } from '@angular/core';
import { CustomFormControl } from '../custom-form-control.component';
import { ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validator } from '@angular/forms';
import { FormatterData } from 'src/app/constants/app.constants';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss', '../../styles/custom-control.styles.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatePickerComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => DatePickerComponent),
      multi: true,
    },
  ],
})
export class DatePickerComponent extends CustomFormControl implements OnInit, ControlValueAccessor, Validator {
  @Input() label: string;
  @Input() dateFormat = FormatterData.date;
  @Input() forceDisable: boolean;
  @Input() name: string;

  constructor(inj: Injector) {
    super(inj);
  }

  ngOnInit(): void {
    this.initBase();
  }

  selectedValue: any = null;

  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: any): void {
    this.selectedValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.applyDisabledState(isDisabled);
  }

  selectValue(data: any): void {
    this.selectedValue = data;

    this.onChange(this.selectedValue); // Notify Angular Forms
    this.onTouched(); // Mark as touched
  }

  registerOnValidatorChange?(fn: () => void): void {}
}
